export const UserStatuses = {
  1: "Activo",
  2: "Bloqueado",
  3: "Restringido"
}

export const RoleLabels = {
  worker: "Trabajador",
  admin: "Administrador",
  manax: "Manax",
  dev: "Desarrollador",
  supervisor: "Supervisor"
}

export const CompanyRoleLabels = {
  worker: "Trabajador",
  admin: "Administrador",
  supervisor: "Supervisor"
}